import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    tone?: 'default' | 'inverted'
    className?: string
    titleId?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    eyebrow,
    title,
    description,
    tone = 'default',
    className,
    titleId
}): ReactNode => {
    const inverted = tone === 'inverted'

    return (
        <div className={cn('max-w-2xl', className)}>
            <p
                className={cn(
                    'flex items-center gap-3 font-mono text-[0.72rem] font-medium uppercase tracking-[0.2em]',
                    inverted ? 'text-glow' : 'text-primary'
                )}
            >
                <span className='h-px w-6 bg-current' aria-hidden='true' />
                {eyebrow}
            </p>

            <h2
                id={titleId}
                className={cn(
                    'mt-5 text-balance text-[2rem] font-light leading-[1.08] tracking-[-0.025em] sm:text-[2.5rem] lg:text-[2.85rem]',
                    inverted ? 'text-ink-foreground' : 'text-foreground'
                )}
            >
                {title}
            </h2>

            {description && (
                <p
                    className={cn(
                        'mt-5 text-pretty text-lg leading-relaxed',
                        inverted ? 'text-ink-foreground/70' : 'text-muted-foreground'
                    )}
                >
                    {description}
                </p>
            )}
        </div>
    )
}
